<template>
  <v-dialog v-model="isOpen" width="515" persistent>
    <template v-slot:activator="{ on }">
      <span class="link" v-on="on">Ver lista completa</span>
    </template>
    <v-card class="pa-5 pb-3">
      <h1 class="mb-6">Produtos</h1>
      <mf-search v-model="search" hide-details dense placeholder="Buscar produto" autofocus />

      <v-data-table
        fixed-header
        disable-pagination
        hide-default-footer
        :headers="headers"
        :height="356"
        :items="filteredProducts"
        no-data-text="Nenhum produto adicionado"
        class="mt-4 mb-2"
      >
        <template v-slot:item="{ item, index }">
          <tr>
            <td class="d-flex justify-center align-center">
              <img v-if="item.image" class="img-container" :src="item.image" :alt="`${item.name} image`" />
              <div v-else class="icon-container d-flex justify-center align-center">
                <mf-icon size="20" color="cinza-d10">image_not_supported</mf-icon>
              </div>
            </td>
            <td>
              <a target="_blank" class="link" :href="link(item)">{{ item.name }}</a>
            </td>
          </tr>
        </template>
      </v-data-table>

      <mf-action-buttons
        :primary-button="{
          text: 'Fechar',
          action: () => (isOpen = false),
          isVisible: true,
          isLoading: false,
        }"
      />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ProductsListDialog',
  components: {},
  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    isOpen: false,
    search: '',
  }),
  computed: {
    headers() {
      return [
        {
          text: '',
          width: '54px',
          value: 'image',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Nome',
          value: 'name',
          width: '',
          sortable: false,
        },
      ]
    },
    filteredProducts() {
      return this.products
        .map((p) => {
          if (p.isGroup) {
            return {
              ...p,
              name: `(Grupo) ${p.name}`,
              image: null,
            }
          }
          return p
        })
        .filter((p) => JSON.stringify(p).toLowerCase().includes(this.search.toLowerCase()))
    },
  },
  methods: {
    link(item) {
      if (item.isGroup) {
        return '#/produtos/gerenciamento-produtos/grupos'
      }
      if (!item.sku) {
        return '#/produtos/gerenciamento-produtos'
      }
      return `#/produtos/detalhes-produto/${item.sku}`
    },
  },
}
</script>

<style lang="scss" scoped>
h1 {
  font-weight: 700;
  font-size: 22px;
  color: $cinza-d10;
}

::v-deep th,
::v-deep td {
  font-size: 14px !important;
  color: $cinza-d20 !important;
  height: 50px;
  padding: 0 8px !important;
}

.img-container,
.icon-container {
  width: 32px;
  height: 32px;
  border: 1px solid $cinza-l60;
  border-radius: 4px;
}

.icon-container {
  background-color: $cinza-l90;
  border: none;
}
</style>
